import { render, staticRenderFns } from "./service-providers.vue?vue&type=template&id=fdf5d7fa&scoped=true"
import script from "./service-providers.vue?vue&type=script&lang=js"
export * from "./service-providers.vue?vue&type=script&lang=js"
import style0 from "./service-providers.vue?vue&type=style&index=0&id=fdf5d7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf5d7fa",
  null
  
)

export default component.exports